import { lazyLoad } from 'utils/loadable';

export const CentreCategorySortListPage = lazyLoad(
  () => import('./index'),
  module => module.CentreCategorySortListPage,
);
